


































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import InfoBar from '@/components/common/InfoBar.vue';
import Menu from '@/components/common/Menu.vue';
import draggable from 'vuedraggable';
import { firewallService } from '@/services/FirewallService';
import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';
import NetworkAddressSelect from '@/components/common/NetworkAddressSelect.vue';
import { portsValidationService } from '@/services/PortsValidation';
import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';
import { mapState } from 'vuex';
import EventBus from '@/EventBus';
import { dedicatedMachineDetailsService } from '@/components/dedicated-machine-edit/services/DedicatedMachineDetailsService';

@Component({
  components: {
    NetworkAddressSelect,
    Header,
    InfoBar,
    Menu,
    draggable,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class Firewall extends Vue {
  workspaceId = 0;
  regionId = 0;
  id = 'latest';
  firewallData: any = [];
  firewallRulesDefault: any = [];
  name = '';
  protocol = '';
  action = '';
  source = '';
  virtualNics: any = [];
  dedicatedNics: any = [];
  dataNics: any = [];
  dataNets: any = [];
  firstFirewallRuleCase = true;
  isLoading = false;
  isValidationActive = false;
  showSuccessModal = false;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    EventBus.$on('firewall_rules_updated', () => {
      this.getFirewallRules();
    });
    this.getFirewallRules();
    virtualMachineDetailsService.getAllNetworkCards(this.workspaceId, this.regionId).then(data => {
      this.virtualNics = data.nics
        .filter((item: any) => item.state === 'idle')
        .map((item: any) => {
          item.type = 'nic';
          item.value = item.ip_address;
          return item;
        });
      dedicatedMachineDetailsService.getAllNetworkCards(this.workspaceId, this.regionId).then(data => {
        this.dedicatedNics = data
          .filter((item: any) => item.state === 'idle')
          .map((item: any) => {
            item.type = 'nic';
            item.value = item.ip_address;
            return item;
          });
        this.dataNics = this.virtualNics.concat(this.dedicatedNics);
      });
    });
    privateNetworkService.getPrivateNetworks(this.workspaceId, this.regionId).then(data => {
      this.dataNets = data.private_networks
        .filter((item: any) => item.state === 'idle')
        .map((item: any) => {
          item.type = 'network';
          item.value = item.network;
          return item;
        });
    });
  }

  isPortValid(rule: any) {
    return portsValidationService.validatePorts(rule.source_port_range, rule.destination_port_range, false);
  }

  removeRule(index: any) {
    this.firewallData[index].isRemoved = true;
    this.firewallData = [...this.firewallData];
  }
  cancelBlur(index: any) {
    this.firewallData[index].isRemoved = false;
    this.firewallData = [...this.firewallData];
  }

  getFirewallRules() {
    firewallService.getFirewallVersions(this.workspaceId, this.regionId).then((data: any) => {
      if (data.firewalls.length) {
        this.id = data.firewalls[data.firewalls.length - 1].id;
        firewallService.getFirewallRules(this.workspaceId, this.regionId, this.id).then((data: any) => {
          this.firewallData = data.firewall_rules.map((item: any, index: number) => {
            item.id = index + 1;
            return item;
          });
          this.firewallRulesDefault = JSON.parse(JSON.stringify(this.firewallData));
          this.firstFirewallRuleCase = true;
        });
      } else {
        this.firewallData = [];
      }
    });
  }

  undoRuleChange(rule: any, index: any, field: any) {
    if (!rule.id) {
      return;
    }
    const data = JSON.parse(JSON.stringify(this.firewallData));
    let original = this.firewallRulesDefault.filter((item: any) => {
      return rule.id === item.id;
    });
    if (!original[0]) {
      return;
    }
    data[index][field] = original[0][field];
    this.firewallData = JSON.parse(JSON.stringify(data));
  }

  ruleHasChanged(rule: any, index: any, field: any) {
    if (!rule.id) {
      return false;
    }
    let original = this.firewallRulesDefault.filter((item: any) => {
      return rule.id === item.id;
    });
    if (!original[0]) {
      return false;
    }
    return JSON.stringify(rule[field]) !== JSON.stringify(original[0][field]);
  }

  cancelChanges() {
    this.firewallData = JSON.parse(JSON.stringify(this.firewallRulesDefault));
  }

  hasChanges() {
    return JSON.stringify(this.firewallRulesDefault) !== JSON.stringify(this.firewallData);
  }

  addNewRule() {
    this.firstFirewallRuleCase = false;
    this.firewallData.push({
      name: '',
      protocol: 'tcp',
      action: 'accept',
      source_port_range: '',
      destination_port_range: '',
      source: {
        type: 'ip_address',
        value: '0.0.0.0',
      },
      destination: {
        type: 'ip_address',
        value: '0.0.0.0',
      },
    });
  }

  saveFirewallRulesDelayed() {
    setTimeout(() => {
      this.saveFirewallRules();
    }, 200);
  }

  saveFirewallRules() {
    this.isValidationActive = true;
    this.firewallData = this.firewallData.filter((item: any) => !item.isRemoved);
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    firewallService
      .updateFirewall(this.workspaceId, this.regionId, { firewall_rules: this.firewallData })
      .then(() => {
        this.isLoading = false;
        this.isValidationActive = false;
        EventBus.$emit('show-success', this.$t('net.firewallRulesSaved'));
        this.showSuccessModal = true;
        this.getFirewallRules();
        if (this.firewallData.length === 0) {
          this.firstFirewallRuleCase = true;
        }
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
